import { render, staticRenderFns } from "./CorporateActivityGeneralInfo.vue?vue&type=template&id=3090291d"
import script from "./CorporateActivityGeneralInfo.vue?vue&type=script&lang=js"
export * from "./CorporateActivityGeneralInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports